module.exports = __webpack_public_path__ + "static/img/day_report_fail.f6b4db3d.png";